// NOTE: If validation needs expand to other forms, We should consider making this 
// a shared utility or leverage using Rails or browser-native constraints.

document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[action*="sign_in"]');
  if (!form) return;

  const submitBtn = form.querySelector('[type="submit"]');
  if (submitBtn) {
    submitBtn.addEventListener('click', function (event) {
      if (!validateLoginForm(form)) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }

  ['username', 'password'].forEach(function (id) {
    const field = document.getElementById(id);
    if (field) {
      field.addEventListener('input', function () {
        clearFieldError(field);
      });
    }
  });
});

const ERROR_MAP = {
  username: 'email-error',
  password: 'password-error'
};

function validateLoginForm(form) {
  let emailValid = validateEmailField(form.querySelector('#username'));
  let passwordValid = validatePasswordField(form.querySelector('#password'));

  return emailValid && passwordValid;
}

function validateEmailField(field) {
  if (!field) return true;

  let error = getEmailError(field.value.trim());
  if (error) {
    applyFieldError(field, error);
    return false;
  }
  return true;
}

function validatePasswordField(field) {
  if (!field) return true;

  if (field.value === '') {
    applyFieldError(field, 'Password is required');
    return false;
  }
  return true;
}

function getEmailError(value) {
  if (value === '') return 'Email is required';
  if (!hasAtSymbol(value)) return "Email should include an '@' in the email address.";
  if (hasMultipleAtSymbols(value)) return "Email should contain only one '@'";
  if (!hasValidFormat(value)) return "Email does not have a valid format";
  return null;
}

function hasAtSymbol(value) {
  return value.includes('@');
}

function hasMultipleAtSymbols(value) {
  return (value.match(/@/g) || []).length >= 2;
}

function hasValidFormat(value) {
  return /^[-a-z0-9_+.]+@([-a-z0-9]+\.)+[a-z0-9]{2,15}$/i.test(value);
}

function applyFieldError(field, message) {
  let errorSpanId = ERROR_MAP[field.id];
  if (!errorSpanId) return;

  field.classList.add('field-error');
  field.setAttribute('aria-invalid', 'true');
  field.setAttribute('aria-describedby', errorSpanId);

  let errorSpan = document.getElementById(errorSpanId);
  if (errorSpan) {
    if (message) {
      errorSpan.textContent = message;
    }
    errorSpan.removeAttribute('hidden');
  }
}

function clearFieldError(field) {
  field.classList.remove('field-error');
  field.removeAttribute('aria-invalid');
  field.removeAttribute('aria-describedby');

  let errorSpanId = ERROR_MAP[field.id];
  if (errorSpanId) {
    let errorSpan = document.getElementById(errorSpanId);
    if (errorSpan) {
      errorSpan.setAttribute('hidden', '');
    }
  }
}

export { validateLoginForm, clearFieldError, getEmailError };
